module.exports = __webpack_public_path__ + "static/media/partners-image-10.9c26cae0.svg";